<template>
    <div class="order-sumamry-container">
        <div class="order-summary-content">
            <div class="page-title">Order Summary</div>
            <div class="order-card">
                <div class="order-content">
                    <img
                        class="order-img"
                        src="../assets/img/courses-image001.jpg"
                        alt=""
                    />
                    <div class="order-info">
                        <div class="order-name">
                            Beginner Chinese for HSK 1 (Full Lessons)
                        </div>
                        <div class="order-price">$35</div>
                    </div>
                </div>
                <el-divider></el-divider>
                <el-row
                    type="flex"
                    class="total-container"
                    justify="space-between"
                >
                    <div class="total-title">Biller Today (USD)</div>
                    <div class="total-amount">$35</div>
                </el-row>
            </div>

            <div class="student-login-details">
                <div class="page-title">Student Login Details</div>
                <div class="page-subtitle">
                    Create an account to access materials related to your
                    purchase
                </div>
                <div class="input-box">
                    <div class="input-label">
                        <span class="madatory">*</span>
                        Email Address
                    </div>

                    <el-input
                        placeholder="Username@gmail.com"
                        v-model="email"
                    ></el-input>

                    <div class="input-label">
                        <span class="madatory">*</span>
                        Full Name
                    </div>

                    <el-input
                        placeholder="Username"
                        v-model="username"
                    ></el-input>

                    <div class="checkbox">
                        <div class="checkbox-square">
                            <el-checkbox v-model="checked" />
                        </div>
                        <div class="checkbox-label">
                            I agree to receive instructional and promotional emails.
                        </div>
                    </div>
                </div>
            </div>

            <div class="payment-infomation">
                <div class="page-title">Payment Information</div>
                <div class="page-subtitle">
                    This is a secure 128-bit SSL encrypted payment
                </div>
                <div class="payment-container">
                    <div class="payment-method">
                        <el-radio v-model="payment" label="1" class="paypal">
                            <img src="../assets/img/gift/icon-paypal.png">
                        </el-radio>
                    </div>
                    <div class="payment-method">
                        <el-radio v-model="payment" label="2" class="all-payment">
                            <p>Credit Card</p>
                            <div class="all-card-type">
                                <img src="../assets/img/gift/icon-mastercard.png">
                                <img src="../assets/img/gift/icon-visa.png">
                                <img src="../assets/img/gift/icon-discover.png">
                                <img src="../assets/img/gift/icon-ae.png">
                            </div>
                        </el-radio>
                        <div class="credit-card-container">
                            <div class="input-label">
                                <span class="madatory">*</span>
                                Card Number
                            </div>

                            <el-input
                                placeholder="1234 1234 1234 1234"
                                v-model="cardNo"
                            ></el-input>

                            <div class="credit-card-detail">
                                <div class="credit-card-date">
                                    <div class="input-label">
                                        <span class="madatory">*</span>
                                        Expiration Date
                                    </div>

                                    <el-input
                                        placeholder="MM/YY"
                                        v-model="expiryDate"
                                    ></el-input>
                                </div>
                                <div class="credit-card-cvc">
                                    <div class="input-label">
                                        <span class="madatory">*</span>
                                        CVC Code
                                        <i class="el-icon-question" @click="cvcDialog = true"></i>
                                    </div>
                                    <el-input
                                        placeholder="000"
                                        v-model="cvc"
                                    ></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="billing-information">
                <div class="page-title">Billing Information</div>

                <div class="billing-container">
                    <div class="addOn-container">
                        <i class="el-icon-circle-plus"></i>
                        <div class="add-on-label">Add Buisness Name</div>
                    </div>
                    <div class="input-label">
                        <span class="madatory">*</span>
                        Country
                    </div>

                    <el-input
                        placeholder="Country"
                        v-model="country"
                    ></el-input>

                    <div class="street-container">
                        <div class="input-label">
                            <span class="madatory">*</span>
                            Street Address
                        </div>

                        <el-input
                            placeholder="Street"
                            v-model="street"
                        ></el-input>
                    </div>

                    <div class="addOn-container">
                        <i class="el-icon-circle-plus"></i>
                        <div class="add-on-label">
                            Add street address line 2
                        </div>
                    </div>

                    <div class="city-state-container">
                        <div class="city-container">
                            <div class="input-label">
                                <span class="madatory">*</span>
                                City
                            </div>

                            <el-input
                                placeholder="City"
                                v-model="city"
                            ></el-input>
                        </div>
                        <div class="addOn-container state-contaienr">
                            <i class="el-icon-circle-plus"></i>
                            <div class="add-on-label">
                                Add State、Province or Region
                            </div>
                        </div>
                    </div>

                    <div class="postal-container">
                        <div class="input-label">
                            <span class="madatory">*</span>
                            Postal Code
                        </div>

                        <el-input
                            placeholder="Postal Code"
                            v-model="postalCode"
                        ></el-input>
                    </div>

                    <div class="checkbox">
                        <div class="checkbox-square">
                            <el-checkbox v-model="sameAddress" />
                        </div>
                        <div class="checkbox-label">
                            Delivery address same as billing
                        </div>
                    </div>
                </div>
            </div>
            <div class="tnc">
                I agree to Teachable’s
                <span class="highlighted">Terms of Use</span> &amp;
                <span class="highlighted">Privacy Policy</span>
                and Online Learning Hub’s
                <span class="highlighted">Terms of Use</span> &amp;
                <span class="highlighted">Privacy Policy</span>
            </div>

            <div class="checkout" @click="this.$router.push('/user/myCourse')">Checkout</div>
        </div>
        <div class="students-testimonial">
            <div class="testimonial-container">
                <div class="title">Students Testimonial</div>
                <img
                    class="student-img"
                    src="../assets/img/student-testimonial001.png"
                    alt=""
                />
                <div class="student-comment">
                    This course is what I have been looking for. The instructors
                    are very clear and don’t speak too fast. Conversations and
                    phrases with grammar explanations, plus the pinyin and
                    character subtitles are very helpful for beginners.
                </div>

                <div class="student-name">— Juliana</div>
                <img
                    class="student-img"
                    src="../assets/img/student-testimonial002.png"
                    alt=""
                />
                <div class="student-comment">
                    I am not a beginner. In fact I am a bit more than half way
                    through HSK3. I am using this beginner course as a
                    refresher, not only for grammar but also for Chinese
                    characters. I have to say that this crisp, well-presented
                    and polished course is not only just well-presented; but the
                    engaging and simplicity of explanations and clarity of
                    spoken Chinese leave many other online courses far behind.
                </div>
                <div class="student-name">— Leonard</div>
            </div>
        </div>

        <el-dialog
            title="CVC Code"
            v-model="cvcDialog"
            custom-class="cvcDialog"
            >
            <img src="../assets/img/cvc.png" >
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "OrderSummary",
    data() {
        return {
            data: {},
            username: "",
            email: "",
            checked: false,
            payment: "1",
            cardNo: "",
            expiryDate: "",
            cvc: "",
            country: "",
            street: "",
            city: "",
            postalCode: "",
            sameAddress: false,
            cvcDialog: false
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {},
    },
};
</script>

<style lang='scss' type='text/css'>
@import "../styles/pc/OrderSummary.scss";
@import "../styles/mobile/OrderSummary.scss";
</style>
